<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="otDetail">
					<!-- 详情 -->
					<div class="otLeftContent">
						<div class="tVideo bd10 p3">
							<h3 class="font30 line-sm t-center">{{content.title}}</h3>
							<div class="dImg line-md">
								<div class="desc" v-html="content.content"></div>
								<div class="tagList t-center" v-if="content.cover">
									<p><br></p>
									<p><br></p>
									<img :src="content.cover" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'ArticleDetail',
  components: {
    
  },
  data() {
    return {
		// 详细信息
		content: {},
	}
  },
  
  created() {
  	  // 获取详细信息
	  this.getContentInfo(this.$route.query.id);
  },
  
  methods: {
  	  // 获取详细信息
  	  getContentInfo(id) {
  		  this.$axios.get(`index/content/details?id=${id}`)
  		  .then(res => {
  			  let data = res.data;
  			  // 当前产品信息
  			  this.content = data;
			  document.title = this.content.title;
  		  })
  		  .catch(err=>{})
  	  }
	  
	},
	
}
</script>

<style lang="less" scoped>
	.otDetail{
		padding-top: .6rem;
		@media (max-width: 1200px) {
			flex-direction: column;
			.otLeftContent,
			.otRightMenu{
				width: 100%;
			}
				
			.otRightMenu{
				margin-top: .3rem;
			}
		}
	}
	
	.otLeftContent{
		& > div:not(:last-child){
			margin-bottom: .1rem;
		}
		.tVideo{
			padding-top: .4rem;
			padding-bottom: .6rem;
			.dImg{
				padding-top: .4rem;
				margin-top: .4rem;
				border-top: solid 1px #eee;
				min-height: 5rem;
			}
			h3{
				margin: .15rem 0 .2rem;
			}
			i{
				margin-right: .2rem;
			}
		}
		@media (max-width: 1200px) {
			.tVideo{
				.dImg{
					min-height: 2rem;
				}
			}
		}
	}
</style>
